import axios, { AxiosInstance } from "axios";
import { AuthUser } from "../../models/AuthUser";
import UserStorage from "../../storages/UserStorage";
import { refreshToken } from "../GuestService";

/* Create basic AxiosInstance with common properties such as 
 * BaseUrl and ContentType format */
const authRestClient: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_REST_BASEURL,
    headers: {
        "Content-Type": "application/json"
    }
});

/* Adds a interceptor for each request made with
 * previous created axiosInstance.
 */
authRestClient.interceptors.request.use(
    (config) => {
        const user: AuthUser | null = UserStorage.getCurrentUser();
        if (user != null)
        {
            /* Add the current valid JWT to the request header */
            config.headers["Authorization"] = "Bearer " + user.token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error); /* Pass on error */
    }
)

/* Add a interceptor for reach response catched | received by the 
 * previous created axiosInstance
 */
authRestClient.interceptors.response.use(
    (response) => {
        return response; /* Just return valid response */
    },
    async (error) => {
        const receivedConfig = error.config;

        if (receivedConfig.url !== "/auth/guest/login" &&
            receivedConfig.url !== "/auth/guest/refresh-token" && error.response)
        {
            /* Check response for "401" error code when endpoint
             * hasn't been guest login endpoint.
             */
            if (error.response.status === 401 && !receivedConfig._retry)
            {
                receivedConfig._retry = true;
                try
                {
                    /* Try to fetch a new valid JWT secret by using a pre-existing refresh token */
                    let authUser: AuthUser | null = UserStorage.getCurrentUser();
                    if (authUser != null)
                    {
                        authUser = await refreshToken(authUser.token, authUser.refreshToken);
                        if (authUser != null)
                        {
                            UserStorage.setUser(authUser);
                            return authRestClient(receivedConfig);
                        }
                        else 
                        {
                            window.location.href = "/login";
                        }
                    }

                    /* You are currently not logged in. 
                     * Reject promise as false, until user is logged in.
                     */
                    return Promise.reject();
                }
                catch (exception)
                {
                    return Promise.reject(exception);
                }
            }
        }
        return Promise.reject(error); /* Pass on error */
    }
);

export default authRestClient;